import { CHASSIS_COLOR_MAPPING } from 'constants/Equipment';
import SessionStore from 'stores/SessionStore';
import { uniqBy } from 'lodash';
/* eslint-disable no-use-before-define */
const CONTAINER = 'container';
const CHASSIS = 'chassis';
const TRAILER = 'trailer';
const UNMAPPED_STATUSES = [
    'pending-admin',
    'pending-shipper',
    'accepted',
    'declined',
];
export function findContainer(equipments = []) {
    return findEquipmentByType(CONTAINER, equipments);
}
export function findChassis(equipments = []) {
    return findEquipmentByType(CHASSIS, equipments);
}
export function findTrailer(equipments = []) {
    return findEquipmentByType(TRAILER, equipments);
}
export function containerExists(equipments = []) {
    return !!findContainer(equipments);
}
export function chassisExists(equipments = []) {
    return !!findChassis(equipments);
}
export function trailerExists(equipments = []) {
    return !!findTrailer(equipments);
}
function findEquipmentByType(type, equipments = []) {
    return equipments.find((e) => e._equipmentType === type);
}
export function getEquipmentBadgeColor(equipment) {
    const { _equipmentType, chassis_owner_type, is_private } = equipment;
    if (_equipmentType === 'trailer')
        return 'gray';
    if (_equipmentType === 'container')
        return 'blue';
    /**
     * If not trailer or container, it will be chassis or user is not admin
     */
    if (!is_private || !SessionStore.isAdmin()) {
        return 'purple';
    }
    return CHASSIS_COLOR_MAPPING[chassis_owner_type];
}
export const getAvailableEquipment = (shipment, equipments = []) => {
    var _a;
    const equipmentIds = equipments.map((eq) => eq._id);
    return uniqBy((((_a = shipment === null || shipment === void 0 ? void 0 : shipment.order) === null || _a === void 0 ? void 0 : _a.equipments) || [])
        .filter((eq) => !equipmentIds.includes(eq))
        .map((eq) => (Object.assign(Object.assign({}, eq), { canAdd: true }))), (eq) => eq._id);
};
export const getUnmappedAccessorialRequests = (shipment, accessorials = []) => {
    return accessorials.filter(({ shipper_status, carrier_status, equipment_id }) => [shipper_status, carrier_status].some((status) => UNMAPPED_STATUSES.includes(status)) &&
        (!(equipment_id === null || equipment_id === void 0 ? void 0 : equipment_id.length) || !shipment.equipments.includes(equipment_id[0])));
};
